import { render } from "./MergeProducts.vue?vue&type=template&id=766e7d6c"
import script from "./MergeProducts.vue?vue&type=script&lang=js"
export * from "./MergeProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__